export const getCategoriesCanonical = (productType, category) => `/${productType.slug}/categoria${category ? `/${category}` : ''}`;